import React from 'react';
import { TextField, useRecordContext, useTranslate } from 'react-admin';

const CategoryField = ({ source, ...props }) => {
    const record = useRecordContext(props);
    const translate = useTranslate();

    const categories = {
        'commemoration': translate('Commemoration'),
        'conference': translate('Conference'),
        'festival': translate('Festival'),
        'guided_tour': translate('Guided tour'),
        'exhibition': translate('Exhibition'),
        'music_theater': translate('Music-Theater'),
        'other': translate('Other')
    };

    if (!record) {
        return null;
    }
    
    const category = record[source];
    if (!category) {
        return null;
    }

    return (
        <TextField {...props} source={category} record={categories} />
    );
};

CategoryField.defaultProps = {
    source: 'category'
};

export default CategoryField;
